(() => {
  const script = document.currentScript;
  if (!script || document.documentElement.hasAttribute('data-ah-cart-ga4-bound')) return;
  document.documentElement.setAttribute('data-ah-cart-ga4-bound', '1');
  const destination = 'G-VWNPB0WWV7';
  const states = new WeakMap();
  const status = (value) => { script.dataset.status = value; };
  const isDrawer = (element) => element?.id === 'cart-drawer';
  const consent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
    return privacy.analyticsProcessingAllowed() === true;
  };
  const transport = () => {
    if (typeof window.gtag === 'function') return window.gtag;
    if (Array.isArray(window.dataLayer)) {
      return function () { window.dataLayer.push(arguments); };
    }
    return null;
  };
  const stateFor = (drawer) => {
    if (!states.has(drawer)) states.set(drawer, { token: 0, sent: false, pending: false, timer: null, controller: null, since: Date.now() });
    return states.get(drawer);
  };
  const reset = (drawer) => {
    const state = stateFor(drawer);
    state.token += 1;
    state.controller?.abort();
    clearTimeout(state.timer);
    state.sent = false;
    state.pending = false;
    state.controller = null;
    state.since = Date.now();
    return state;
  };
  const makePayload = (cart) => {
    const country = script.dataset.country;
    if (!/^[A-Z]{2}$/.test(country || '') || !/^[A-Z]{3}$/.test(cart.currency || '') || !Array.isArray(cart.items)) throw new Error('invalid_cart');
    if (!Number.isSafeInteger(cart.total_price) || cart.total_price < 0) throw new Error('invalid_total');
    const items = cart.items.map((item) => {
      if (!Number.isSafeInteger(item.product_id) || !Number.isSafeInteger(item.variant_id) || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || !Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) throw new Error('invalid_item');
      return {
        item_id: `shopify_${country}_${item.product_id}_${item.variant_id}`,
        item_name: item.product_title || item.title,
        item_brand: item.vendor,
        item_category: item.product_type,
        item_variant: item.variant_title || '',
        price: item.final_line_price / item.quantity / 100,
        quantity: item.quantity
      };
    });
    const payload = { send_to: destination, currency: cart.currency, value: cart.total_price / 100, items, cart_surface: 'drawer' };
    if (script.dataset.debug === 'true') payload.debug_mode = true;
    return payload;
  };
  const attempt = async (drawer) => {
    const state = stateFor(drawer);
    clearTimeout(state.timer);
    if (!drawer.isConnected || !drawer.hasAttribute('open') || state.sent || state.pending) return;
    const permitted = consent();
    if (permitted === false) { status('consent_denied'); return; }
    const send = transport();
    if (permitted === null || !send) {
      status(permitted === null ? 'waiting_consent_api' : 'waiting_google_tag');
      if (Date.now() - state.since < 15000) state.timer = setTimeout(() => attempt(drawer), 250);
      else status('tracking_dependency_unavailable');
      return;
    }
    const token = state.token;
    state.pending = true;
    const controller = new AbortController();
    state.controller = controller;
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(script.dataset.cartUrl, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('cart_request_failed');
      const cart = await response.json();
      if (state.token !== token || !drawer.isConnected || !drawer.hasAttribute('open') || consent() !== true) return;
      const payload = makePayload(cart);
      const currentTransport = transport();
      if (!currentTransport) throw new Error('tracking_dependency_unavailable');
      state.sent = true;
      currentTransport('event', 'view_cart', payload);
      status('queued');
    } catch (error) {
      if (state.token === token) status(error.name === 'AbortError' ? 'cancelled' : 'tracking_error');
    } finally {
      clearTimeout(timeout);
      if (state.token === token) { state.pending = false; state.controller = null; }
    }
  };
  document.addEventListener('dialog:before-show', (event) => {
    if (isDrawer(event.target)) reset(event.target);
  }, true);
  document.addEventListener('dialog:after-show', (event) => {
    if (isDrawer(event.target)) attempt(event.target);
  }, true);
  document.addEventListener('dialog:before-hide', (event) => {
    if (isDrawer(event.target)) reset(event.target);
  }, true);
  document.addEventListener('visitorConsentCollected', () => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer?.hasAttribute('open')) {
      stateFor(drawer).since = Date.now();
      attempt(drawer);
    }
  });
  status('ready');
  const drawer = document.getElementById('cart-drawer');
  if (drawer?.hasAttribute('open')) attempt(drawer);
})();
